<template>
  <div>
    <please-wait-modal/>
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">Change Password</h1>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <div class="row px-3">
            <label for="#form-name" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Old Password</label>
            <input type="password" class="form-control col-lg-8" id="form-name" v-model="old_password"/>
          </div>
        </div>
        <div class="form-group">
          <div class="row px-3">
            <label for="#form-name" class="col-lg-4 pl-0 m-0 d-flex align-items-center">New Password</label>
            <input type="password" class="form-control col-lg-8" id="form-name" v-model="new_password"/>
          </div>
        </div>
        <div class="form-group">
          <div class="row px-3">
            <label for="#form-name" class="col-lg-4 pl-0 m-0 d-flex align-items-center">Confirm Password</label>
            <input type="password" class="form-control col-lg-8" id="form-name" v-model="confirm_password"/>
          </div>
        </div>
        <div class="form-group text-right">
          <a type="button" class="btn btn-danger" href="/">Cancel</a>
          <button type="button" class="btn btn-primary" @click="save">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'summernote/dist/summernote.css'
import summernote from 'summernote'

import please_wait_modal from '@/layout/please_wait_modal'
import modal_edit from '@/pages/master/helper_sub_category/modal_edit_sub_sub_category'

export default {
  components:{
    'please-wait-modal': please_wait_modal,
    'modal-edit': modal_edit,
  },
  data(){
    return{
      old_password: '',
      new_password: '',
      confirm_password: '',
    }
  },
  methods:{
    async save(){
      try{
        if(this.old_password == '')
          this.$toasted.show('Old Password is empty')
        else if(this.new_password == '')
          this.$toasted.show('New Password is empty')
        else if(this.confirm_password == '')
          this.$toasted.show('Confirm Password is empty')
        else if(this.confirm_password != this.new_password)
          this.$toasted.show('Confirm Password is not same with New Password')
        else{
          $('#please_wait_modal').modal('show')
          var data = {}
          data.old_password = this.old_password
          data.password = this.new_password

          var response = await axios.put(base_url+'/auth/change_password',data)

          $('#please_wait_modal').modal('hide')
          var response_data = response.data
          if(response_data.status == "success"){
            location.href = '/'
          }
          else
            this.$toasted.show(response_data.message)
        }
      } catch(e){
        $('#please_wait_modal').modal('hide')
        this.$toasted.show(e)
      }
    },
  }
}
</script>
